import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-arrows-icon',
  templateUrl: './design-arrows.component.html'
})
export class DesignArrowsComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
